import React from "react";
import { classnames } from "../utils/general";

const CustomInput = ({ testCaseInput, setTestCaseInput, ...rest }) => {
  return (
    <div className="w-[50%] flex flex-col">
      <h1
        className="flex items-center justify-start font-bold 
        text-base w-full bg-black-glaze text-white pl-5 py-3"
      >
        Test case input details
      </h1>
      <div className="custom-input-container h-[220px] overflow-auto">
        {testCaseInput?.map(({ input, output }, index) => (
          <div key={index} className="ml-4 mt-1">
            <pre className="font-bold text-md text-white mt-4">
              {`Test-Case ${index + 1} Input:`}
            </pre>
            <div className="flex flex-col">
              {input && input.split('\n').map((line, i) => (
                <span className="px-2 py-1 font-normal text-md text-white" key={i}>
                  {line}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomInput;
